module.exports = __webpack_public_path__ + "static/media/planEmerg_2.ae12ff8d.png";